import Header from "@/atomic/atoms/Header";
import { PropsView } from "./Models";

export default function PolicyView({ goBack }: PropsView) {
  return (
    <div className="h-full">
      <div
        id="otnotice-1ef0a230-db30-4fa6-8368-96c76ba2e4bc"
        className="otnotice"
      ></div>
      <Header title="Política de Privacidade" goBack={goBack} hasLeftButton />
      <main className="p-2 w-full flex justify-center h-[calc(100%-72px)] text-black h-form">
        <div className="h-full flex flex-col justify-between w-full">
          <div className="w-full h-full">
            <iframe
              title="Política de Privacidade"
              src="/politicas-de-privacidade.pdf"
              width="100%"
              height="100%"
            ></iframe>
          </div>
        </div>
      </main>
    </div>
  );
}
